import React, { type PropsWithChildren } from 'react';

import {
	COMPANY_MANAGED_PROJECT,
	TEAM_MANAGED_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';
import { FabricElementsAnalyticsContext } from '@atlaskit/analytics-namespaced-context';
import { useIsAdmin } from '@atlassian/jira-tenant-context-controller/src/components/is-admin/index.tsx';
import { useProjectContext } from '@atlassian/jira-providers-project-context/src/index.tsx';
import { ContextualAnalyticsData } from '@atlassian/jira-product-analytics-bridge';
import { useCurrentRoute } from '@atlassian/jira-platform-router-utils/src/index.tsx';

const useLocationAndRouteName = () => {
	const route = useCurrentRoute();

	return {
		userLocation: `${route.group ?? 'unknown'}:${route.name ?? 'unknown'}`,
		routeName: route.name,
	};
};

export const AnalyticsWrapper = ({ children }: PropsWithChildren<{}>) => {
	const { data } = useProjectContext();
	const projectType = data?.projectType;
	const projectStyle = data?.simplified ? TEAM_MANAGED_PROJECT : COMPANY_MANAGED_PROJECT;
	const isAdmin = useIsAdmin();
	const isProjectAdmin = data?.isProjectAdmin || false;
	const routeInfo = useLocationAndRouteName();

	const analyticsData = {
		isAdmin,
		...routeInfo,
		projectType,
		projectStyle,
		isProjectAdmin,
	};

	return (
		<ContextualAnalyticsData attributes={analyticsData}>
			<FabricElementsAnalyticsContext data={analyticsData}>
				{children}
			</FabricElementsAnalyticsContext>
		</ContextualAnalyticsData>
	);
};
